import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./contexts/Auth";
import Login from "./views/Login";
import Internal from "./views/Internal";
import Onboarding from "./views/Onboarding/Onboarding";
import OnboardingDetails from "./views/Onboarding/OnboardingDetails";
import Rejected from "./views/Onboarding/Rejected";
import Transactions from "./views/Transactions";
import ConnectedAccounts from "./views/ConnectedAccounts";
import UserManagement from "./views/UserManagement";
import Embedded from "./views/Embedded";
import Wallets from "./views/Wallets";
import ExternalEmbeddedOutlet from "./views/ExternalEmbeddedOutlet";
import { ToastProvider } from "./contexts/ToastContext";
import "./App.css";
import Api from "./views/Api/Api";
import Settings from "./views/Settings";
import AuditLogs from "./views/AuditLogs";
import BusinessOnboarding from "./components/BusinessOnboarding";
import Demo from "./views/Demo";

export function App() {
  const embeddedView = window.location.href.includes("external-embedded");
  return (
    <Router>
      {embeddedView && (
        <Routes>
          <Route
            path="/external-embedded"
            element={<ExternalEmbeddedOutlet />}
          />
        </Routes>
      )}
      {!embeddedView && (
        <ToastProvider>
          <AuthProvider>
            <Routes>
              <Route index path="/login" Component={Login} />
              <Route index path="/accounts/rejected" element={<Rejected />} />
              <Route
                path="/business-onboarding"
                element={<BusinessOnboarding />}
              />
              <Route path="/" element={<Internal />}>
                <Route index path="/accounts" element={<Onboarding />} />
                <Route path="/transactions" element={<Transactions />} />
                <Route path="/balances" element={<Wallets />} />
                <Route path="/wallets" element={<Wallets />} />
                <Route
                  path="/connected-accounts"
                  element={<ConnectedAccounts />}
                />
                <Route path="/audit-logs" element={<AuditLogs />} />
                <Route path="/embedded" element={<Embedded />} />
                <Route path="/user-management" element={<UserManagement />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/api" element={<Api />} />
                <Route path="/accounts/:id" element={<OnboardingDetails />} />
                <Route path="/" element={<Navigate to="/accounts" />} />
                <Route path="/demo" element={<Demo />} />
              </Route>
            </Routes>
          </AuthProvider>
        </ToastProvider>
      )}
    </Router>
  );
}
